import exponent from "./exponent.js";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/~/d3-format/src/precisionFixed.js
// module id = p0x0
// module chunks = 0